import { render } from "./ClienteImagenes.vue?vue&type=template&id=274ad62a&scoped=true"
import script from "./ClienteImagenes.vue?vue&type=script&lang=js"
export * from "./ClienteImagenes.vue?vue&type=script&lang=js"

import "./ClienteImagenes.vue?vue&type=style&index=0&id=274ad62a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274ad62a"]])

export default __exports__